import type { ComponentProps } from "react";
import { useQuery } from "@tanstack/react-query";
import { t } from "ttag";

import { ErrorModal } from "@/app/components/legacy-modals";
import { formQueriesStore } from "@/features/forms/api";
import { CheckableCardsSkeleton, ClockIcon, Dialog } from "@/shared/ui";
import { CancellationReasonsSelection } from "./cancellation-reasons-selection";

export const CancellationReasonsModal = (
  props: ComponentProps<typeof Dialog.Root>,
) => {
  const {
    data: options,
    isLoading,
    isSuccess,
    isError,
  } = useQuery({
    ...formQueriesStore.cancellationReasons,
    staleTime: Infinity,
  });

  if (isError) {
    return <ErrorModal {...props} />;
  }

  return (
    <Dialog.Root {...props}>
      <Dialog.Content>
        <Dialog.Header icon={ClockIcon}>
          <Dialog.Title>{t`Can we do better?`}</Dialog.Title>
          <Dialog.Description>
            {t`Before you cancel your subscription, we want to understand what led to your decision. Please select all that apply.`}
          </Dialog.Description>
        </Dialog.Header>

        {isLoading && <CheckableCardsSkeleton className="pt-10" count={5} />}

        {isSuccess && <CancellationReasonsSelection options={options} />}
      </Dialog.Content>
    </Dialog.Root>
  );
};
